import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class SetFormService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getFormulario(idFormulario): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_FORMULARIO + "/" + idFormulario;
    return this.http.get<any>(url).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Formulario",
            text: "Error Cargando Formulario.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getFormularioReporte(idReporte): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_REPORTE + "/" + idReporte;
    //alert(url);
    return this.http.get<any>(url).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Reporte",
            text: "Error Cargando Reporte.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public postFormulario(infoPayload): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_FORMULARIO;

    const token = sessionStorage.getItem("token");
    const httpHeaders = new HttpHeaders()
      .set("Authorization", "Bearer " + token)
      .set("Content-Type", "application/json");

    return this.http
      .post<any>(url, infoPayload, { headers: httpHeaders })
      .pipe(
        catchError((err) => {
          if (err.status === 401) {
            this.utils.cerrarSesion();
          } else {
            Swal.fire({
              title: "Error Formulario",
              text: "Verifique la informacion ingresada.",
              icon: "error",
            });
          }

          return throwError(err);
        })
      );
  }
}
